import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_role } from './ENUM__invocation_role';
import { CONSTRUCTOR_INVOCATION, INVOCATION__base } from './INVOCATION__base';

export function FN_INVOCATION__create<T extends INVOCATION__base>(
  type_constructor: new () => T,
  graph: DTO_GRAPH__instance,
  node_role: string = ENUM__invocation_role.UNKNOWN,
): T {

  let already_exists_on_graph = graph.node_role__has_node(node_role);

  if (node_role != ENUM__invocation_role.UNKNOWN && already_exists_on_graph) {
    let out_from_graph = graph.node_role__get_node(node_role);

    //todo: check intance type and mb convert node
    assert_instanceof(out_from_graph, type_constructor);

    return out_from_graph;
  }

  // We cast 'this' to any or the interface to access the meta methods
  // while keeping the return type T
  const constructor = type_constructor as unknown as CONSTRUCTOR_INVOCATION<T>;

  let out = new type_constructor() as T;
  out.meta = constructor.create_default_meta();
  out.meta.node_role = node_role;

  out.post_init();

  graph.node__add(out);

  // FN_FIELD_CONTAINER__init_stubs(out);
  // FN_FIELD_CONTAINER__init_as_default(out);

  return out;
}
